
import R from "ramda";
import { store } from "store";
import { createIncludeRules, deleteIncludeRule } from "api/categories";
import { fetchDocuments, mergeVendors } from "api/documents";
import { setFlashGenericErrorAction, setFlashMessageAction } from "actions/app-actions";
import { fetchVendors } from "../api/vendors";

export const FETCH_VENDORS = "actions/manage-vendors/fetch-vendors";
export const LOADING_START = "actions/manage-vendors/loading-start";
export const LOADING_STOP = "actions/manage-vendors/loading-stop";
export const SELECT_VENDORS = "actions/manage-vendors/select-vendors";
export const DESELECT_VENDORS = "actions/manage-vendors/deselect-vendors";
export const ADD_VENDOR_RULES = "actions/manage-vendors/add-vendor-rules";
export const REMOVE_VENDOR_RULES = "actions/manage-vendors/remove-vendor-rules";
export const ADD_VENDOR_RULES_LOADING = "actions/manage-vendors/add-vendor-rules-loading";
export const REMOVE_VENDOR_RULES_LOADING = "actions/manage-vendors/remove-vendor-rules-loading";
export const ADD_VENDOR_RULES_LOADING_STOP = "actions/manage-vendors/add-vendor-rules-loading-stop";
export const REMOVE_VENDOR_RULES_LOADING_STOP = "actions/manage-vendors/remove-vendor-rules-loading-stop";
export const START_ADD_VENDOR_RULES_MODE = "actions/manage-vendors/start-add-vendor-rules-mode";
export const END_ADD_VENDOR_RULES_MODE = "actions/manage-vendors/end-add-vendor-rules-mode";
export const SELECT_CATEGORY_FOR_RULE = "actions/manage-vendors/select-category-for-rule";
export const DELETE_VENDOR_RULE = "actions/manage-vendors/delete-vendor-rule";
export const ORDER_VENDORS = "actions/manage-vendors/order-vendors";
export const START_MERGE_VENDORS_MODE = "actions/manage-vendors/start-merge-vendors-mode";
export const END_MERGE_VENDORS_MODE = "actions/manage-vendors/end-merge-vendors-mode";
export const MERGE_VENDORS = "actions/manage-vendors/merge-vendors";
export const SELECT_MERGE_VENDOR = "actions/manage-vendors/select-merge-vendor";
export const MERGE_VENDORS_LOADING_START = "actions/manage-vendors/merge-vendors-loading-start";
export const MERGE_VENDORS_LOADING_STOP = "actions/manage-vendors/merge-vendors-loading-stop";

export const fetchVendorsAction = () => (dispatch) => {
  dispatch({ type: LOADING_START });
  const state = store.getState();
  const vendors = state.vendors.vendors;
  const categories = state.categories.categories;
  const newVendors = vendors.map((vendor) => {
    const rules = categories.filter((category) => {
      if (R.findIndex(R.propEq("vendorName", vendor.name))(category.rules.includeVendors) > -1) {
        return category;
      }
      return null;
    });
    const newVendor = R.clone(vendor);
    newVendor.id = vendor.name;
    return R.assoc("rules", rules, newVendor);
  });
  return dispatch({
    type: FETCH_VENDORS,
    data: { newVendors }
  });
};

export const selectVendorsAction = (vendorIds) => ({
  type: SELECT_VENDORS,
  data: { vendorIds }
});

export const deselectVendorsAction = (vendorIds) => ({
  type: DESELECT_VENDORS,
  data: { vendorIds }
});

export const addVendorRulesAction = () => (dispatch) => {
  const state = store.getState();
  const categories = state.categories.categories;
  const accountId = state.app.selectedAccount.id;
  const vendors = state.vendors.selectedVendorIds;
  const category = state.vendors.selectedCategory;
  dispatch({ type: ADD_VENDOR_RULES_LOADING });
  const newVendors = vendors.map((vendor) => ({ vendorName: vendor }));
  return createIncludeRules(accountId, category.info, newVendors)
    .then((response) => {
      const vendorRule = response[0].data;
      dispatch({ type: ADD_VENDOR_RULES, data: { vendors, category, vendorRule, categories } });
      dispatch({ type: ADD_VENDOR_RULES_LOADING_STOP });
      dispatch(setFlashMessageAction("Rule added"));
    })
    .catch(() => {
      dispatch(setFlashGenericErrorAction());
      dispatch({ type: ADD_VENDOR_RULES_LOADING_STOP });
    });
};

export const startAddVendorRulesModeAction = () => ({
  type: START_ADD_VENDOR_RULES_MODE
});

export const endAddVendorRulesModeAction = () => ({
  type: END_ADD_VENDOR_RULES_MODE
});

export const selectCategoryForRuleAction = (category) => ({
  type: SELECT_CATEGORY_FOR_RULE,
  data: { category }
});

export const deleteIncludeRuleAction = (accountId, category, vendor) => (dispatch) => (
  deleteIncludeRule(accountId, category.id, vendor.id)
    .then(() => {
      dispatch({
        type: DELETE_VENDOR_RULE,
        data: { vendor, category }
      });
      dispatch(setFlashMessageAction("Rule removed", "error"));
    })
);

export const orderVendorsAction = (column) => ({
  type: ORDER_VENDORS,
  data: { column }
});

export const startMergeVendorsModeAction = () => ({
  type: START_MERGE_VENDORS_MODE
});

export const endMergeVendorsModeAction = () => ({
  type: END_MERGE_VENDORS_MODE
});

export const selectMergeVendorAction = (vendor) => ({
  type: SELECT_MERGE_VENDOR,
  data: { vendor }
});

export const mergeVendorsAction = (accountId, vendor, vendors) => (dispatch) => {
  dispatch({ type: MERGE_VENDORS_LOADING_START });
  const dropSelected = (vendorName) => vendorName === vendor.key;
  const limit = { limit: 0, pageNumber: 1 };
  const filterData = {
    orderBy: "uploaded",
    orderDirection: "DSC",
    processingState: "PROCESSED",
    isTrash: false,
    selectedVendors: R.dropWhile(dropSelected, vendors)
  };
  return fetchDocuments(accountId, filterData, limit)
    .then(({ documents }) => mergeVendors(accountId, documents, vendor.key))
    .then(() => fetchVendors(accountId))
    .then((response) => {
      dispatch({
        type: MERGE_VENDORS,
        data: { vendors: response.vendors }
      });
      dispatch({ type: MERGE_VENDORS_LOADING_STOP });
    })
    .then(() => dispatch(fetchVendorsAction()));
};



// WEBPACK FOOTER //
// ./src/js/actions/vendors-actions.js